<script>
    export default {
        methods: {
            registerEvents() {
                $(this.$el).on('change', '#health_insurance_type_id', (e) => {
                    if (parseInt($(e.currentTarget).val()) === 2) { // Privat versichert
                        $(this.$el).find('#health_insurance_contribution_wrapper, #care_insurance_contribution_wrapper').show();
                        $(this.$el).find('#health_insurance_self_transfer_wrapper').hide();
                        $(this.$el).find('#health_insurance_self_transfer').val('');
                    } else if (parseInt($(e.currentTarget).val()) === 3) { // Freiwillig gesetzlich versichert
                        $(this.$el).find('#health_insurance_self_transfer_wrapper').show();
                        $(this.$el).find('#health_insurance_contribution_wrapper, #care_insurance_contribution_wrapper').hide();
                        $(this.$el).find('#health_insurance_contribution, #care_insurance_contribution').val('');
                    } else {
                        $(this.$el).find('#health_insurance_contribution, #care_insurance_contribution').val('');
                        $(this.$el).find('#health_insurance_contribution_wrapper, #care_insurance_contribution_wrapper, #health_insurance_self_transfer_wrapper').hide();
                    }
                });

            }
        },

        mounted() {
            this.$nextTick(() => {
                this.registerEvents();
            })
        }
    }
</script>
